import { BuildingOffice2Icon, MapPinIcon, PhoneIcon } from '@heroiconsv2/react/24/outline'
import { LABEL, PANEL, ROW_START, SectionCard } from './BookingSection'

const ContactRows = ({ entity, t }) => (
  <div className={PANEL}>
    <div className={ROW_START}>
      <div className={LABEL}>{t('booking.labels.name')}</div>
      <div className="text-sm text-slate-800 sm:text-right break-words">{entity?.name || '-'}</div>
    </div>

    <div className={ROW_START}>
      <div className={LABEL}>{t('booking.labels.email')}</div>
      <div className="text-sm text-slate-800 sm:text-right break-all">{entity?.email || '-'}</div>
    </div>

    {entity?.phones?.length > 0 ? (
      entity.phones.map((phoneData, index) => (
        <div key={index} className={ROW_START}>
          <div className={LABEL}>{phoneData.title}</div>
          <a href={`tel:${phoneData.phone}`} className="inline-flex items-center gap-1.5 text-sm text-slate-800 hover:text-blue-700 sm:justify-end" dir="ltr">
            <PhoneIcon className="h-4 w-4 text-blue-600" />
            {phoneData.phone}
          </a>
        </div>
      ))
    ) : (
      <div className={ROW_START}>
        <div className={LABEL}>{t('booking.labels.phone') || 'Phone'}</div>
        <div className="text-sm text-slate-800 sm:text-right">-</div>
      </div>
    )}
  </div>
)

const BookingCompanyBranchCard = ({ bookingData, t }) => (
  <>
    <SectionCard icon={BuildingOffice2Icon} title={t('booking.sections.companyDetails')}>
      <ContactRows entity={bookingData?.rentalCar?.company} t={t} />
    </SectionCard>
    <SectionCard icon={MapPinIcon} title={t('booking.sections.branchDetails')}>
      <ContactRows entity={bookingData?.branch} t={t} />
    </SectionCard>
  </>
)

export default BookingCompanyBranchCard
